export type Station = {
  name: string;
  url: string;
  logo?: string;
  genres: string[];
};

const ATTRIBUTE = /([a-z-]+)="([^"]*)"/g;

function parseExtinf(line: string): Omit<Station, "url"> {
  // Format: #EXTINF:<duration> key="value" ...,<name>
  // The name follows the first comma after the last attribute.
  const body = line.slice("#EXTINF:".length);
  const lastQuote = body.lastIndexOf('"');
  const comma = body.indexOf(",", lastQuote + 1);
  const name = comma === -1 ? "" : body.slice(comma + 1).trim();
  const attributes = Object.fromEntries(
    Array.from(body.slice(0, comma === -1 ? undefined : comma).matchAll(ATTRIBUTE), (m) => [m[1], m[2]])
  );

  return {
    name: name || "Unnamed station",
    logo: attributes["tvg-logo"] || undefined,
    genres: (attributes["group-title"] ?? "")
      .split(",")
      .map((genre) => genre.trim())
      .filter(Boolean),
  };
}

export function parseM3U(text: string): Station[] {
  const stations: Station[] = [];
  let pending: Omit<Station, "url"> | null = null;

  for (const raw of text.split(/\r?\n/)) {
    const line = raw.trim();
    if (!line) continue;

    if (line.startsWith("#EXTINF:")) {
      pending = parseExtinf(line);
    } else if (!line.startsWith("#")) {
      stations.push({ ...(pending ?? { name: line, genres: [] }), url: line });
      pending = null;
    }
  }

  return stations;
}

// Identifies a station across reloads; the playlist has no ids of its own.
export function stationKey(station: Station): string {
  return `${station.name}\n${station.url}`;
}
